var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessHuge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 0C14.85 0 0 14.85 0 33C0 51.15 14.85 66 33 66C51.15 66 66 51.15 66 33C66 14.85 51.15 0 33 0ZM48.0562 27.4312L28.875 46.6125C28.2563 47.2313 27.4312 47.4375 26.6062 47.4375C25.7812 47.4375 24.9563 47.2313 24.3375 46.6125L16.5 38.775C15.2625 37.5375 15.2625 35.6813 16.5 34.4438C17.7375 33.2063 19.5938 33.2063 20.8313 34.4438L26.6062 40.2188L43.725 23.1C44.9625 21.8625 46.8187 21.8625 48.0562 23.1C49.2937 24.3375 49.2937 26.1938 48.0562 27.4312Z",
    fill: "#6EDC5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessHuge);
export default __webpack_public_path__ + "static/media/success_huge.e513a6c9c5de3588b7cc11beac180593.svg";
export { ForwardRef as ReactComponent };